import { useState, useEffect } from "react";

import { GetDashboardInfoController } from "../../../Controllers/HelpDesk/Dashboard/DashboardControllers";
import { ListarEquipesController } from "../../../Controllers/HelpDesk/Equipes/EquipesControllers";

import { IEquipe } from "../../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import { IAtendimentoFechado } from "../../../Interfaces/HelpDesk/Dashboard/DashboardInterfaces";

import AtendentesOnline from "./AtendentesOnline";
import AtendimentosPorPeriodoChart from "./Charts/AtendimentosPorPeriodoChart";
import AtendimentosPorEquipeChart from "./Charts/AtendimentosPorEquipeChart";
import AtendimentosMaisAntigosChart from "./Charts/AtendimentosMaisAntigosChart";
import {
    getChatsRef,
    getConversaRef,
} from "../../../Services/Config/ConfigFirebase";
import { useUserInfor } from "../../../Context/User";
import {
    IChat,
    IChatComStatus,
} from "../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { get, off, onValue, Query } from "firebase/database";
import AtendimentosComMaiorAguardoPorParteDoClienteChart from "./Charts/AtendimentosComMaiorAguardoPorParteDoClienteChart";
import ClientesHaMaisTempoNaFilaChart from "./Charts/ClientesHaMaisTempoNaFilaChart";
import { ErrorBoundary } from "../../../Components/ErrorBoundary";

export default function DashboardHelpDesk() {
    const [massaDeDados, setMassaDeDados] = useState<
        Array<IAtendimentoFechado>
    >([]);
    const [equipes, setEquipes] = useState<Array<IEquipe>>([]);

    const { OrgInfor } = useUserInfor();
    const listaChatsAbertosFirebase = useFirebaseDataForDashboard({
        ID_ORGANIZACAO: OrgInfor.ID_ORGANIZACAO,
        equipes,
    });

    useEffect(() => {
        Promise.all([
            ListarEquipesController(),
            GetDashboardInfoController(),
        ]).then((res) => {
            const [equipes, massaDeDados] = res;
            setMassaDeDados(massaDeDados);
            setEquipes(equipes);
        });
    }, []);

    return (
        <div className="row">
            <ErrorBoundary>
                <div className="col-12 col-md-6">
                    <div className="card">
                        <div className="card-body">
                            <AtendentesOnline />
                        </div>
                    </div>
                    <div className="card my-10">
                        <div className="card-body">
                            <AtendimentosComMaiorAguardoPorParteDoClienteChart
                                listaChatsAbertosFirebase={
                                    listaChatsAbertosFirebase
                                }
                            />
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <AtendimentosPorPeriodoChart
                                massaDeDados={massaDeDados}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="card">
                        <div className="card-body">
                            <AtendimentosPorEquipeChart
                                massaDeDados={massaDeDados}
                                equipes={equipes}
                            />
                        </div>
                    </div>
                    <div className="card mt-10">
                        <div className="card-body">
                            <AtendimentosMaisAntigosChart
                                listaChatsAbertosFirebase={
                                    listaChatsAbertosFirebase
                                }
                            />
                        </div>
                    </div>
                    <div className="card mt-10">
                        <div className="card-body">
                            <ClientesHaMaisTempoNaFilaChart
                                listaChatsAbertosFirebase={
                                    listaChatsAbertosFirebase
                                }
                            />
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        </div>
    );
}

function useFirebaseDataForDashboard(props: {
    equipes: Array<IEquipe> | undefined;
    ID_ORGANIZACAO: string;
}) {
    const { ID_ORGANIZACAO, equipes } = props;

    const [lstAtendimentoemAberto, setlstAtendimentoemAberto] =
        useState<Array<IChatComStatus>>();

    useEffect(() => {
        const refs: Array<Query> = [];

        if (equipes) {
            equipes.forEach((equipe) => {
                // @ts-ignore
                const nrTelefoneEquipe: string = equipe.NR_TELEFONE;
                const chatRef = getChatsRef(ID_ORGANIZACAO, nrTelefoneEquipe);
                refs.push(chatRef);
                onValue(
                    chatRef,
                    async (snap) => {
                        const chats: Array<IChatComStatus> = [];
                        snap.forEach((childSnap) => {
                            const chat: IChat = childSnap.val();
                            chats.push({
                                ...chat,
                            });
                        });

                        Promise.all(
                            chats.map(async (chat) => {
                                chat.conversa = [];
                                const conversaRef = getConversaRef(
                                    ID_ORGANIZACAO,
                                    nrTelefoneEquipe,
                                    chat.NumeroCliente
                                );
                                await get(conversaRef).then((conversaSnap) => {
                                    conversaSnap.forEach((mensagem) => {
                                        chat.conversa?.push(mensagem.val());
                                    });
                                });
                            })
                        ).then(() => {
                            setlstAtendimentoemAberto(chats);
                        });
                    },
                    { onlyOnce: true }
                );
            });
        }
        return function cleanup() {
            refs.forEach((ref) => {
                off(ref);
            });
        };
    }, [ID_ORGANIZACAO, equipes]);

    return lstAtendimentoemAberto;
}
